import { render, staticRenderFns } from "./Thread.vue?vue&type=template&id=33f2b2b7&scoped=true&lang=pug&"
import script from "./Thread.vue?vue&type=script&lang=ts&"
export * from "./Thread.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f2b2b7",
  null
  
)

export default component.exports